import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class CitietouristicService {
  constructor(private http: HttpClient, private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('citietouristic/all', val_params);
  }
  
  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('citietouristic/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('citietouristic/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('citietouristic/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('citietouristic/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('citietouristic/delete', val_id);
  }
}
